import React from 'react'
import agent from '../agent'
import { store } from '../store'
import { push } from 'react-router-redux'
import { connect } from 'react-redux'
import ListErrors from './widgets/ListErrors'
import { Translation } from 'react-i18next'
import i18n from '../languages/lang.js'
import {
    GET_PIN_CODE,
    LOGIN_PAGE_VERIFY_PIN_CODE,
    VERIFY_PIN_CODE_UNLOADED,
} from '../constants/actionTypes'

const mapStateToProps = state => ({
    ...state.auth,
    inProgress: state.common.inProgress
})

const mapDispatchToProps = dispatch => ({
    onGetPinCode: (payload, userKey, phone) => {
        dispatch({ type: GET_PIN_CODE, payload, userKey, phone })
    },
    onCheckPinCode: (payload, userKey, phone) => {
        dispatch({ type: LOGIN_PAGE_VERIFY_PIN_CODE, payload, userKey, phone })
    },
    onUnload: () =>
        dispatch({ type: VERIFY_PIN_CODE_UNLOADED })
})

class Verification extends React.Component {
    constructor() {
        super()
        this.state = {
            userKey: null,
            phone: null,
            code: ''
        }
        this.updateState = field => ev => {
            const state = this.state;
            const newState = Object.assign({}, state, { [field]: ev.target.value });
            this.setState(newState);
        }
        this.checkPinCode = (code) => ev => {
            ev.preventDefault()
            const payload = agent.Auth.verifyPinCode(this.state.userKey, code, 'login');
            this.props.onCheckPinCode(payload)
        }
    }
    componentWillMount(props) {
        if (this.props.userKey) {
            Object.assign(this.state, {
                userKey: this.props.userKey,
                phone: this.props.phone,
            })
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.redirectTo) {
            store.dispatch(push(nextProps.redirectTo))
            this.props.onRedirect()
        }
    }
    componentWillUnmount() {
        this.props.onUnload()
    }

    render() {
        const code = this.state.code || ''
        return (
            <Translation>
                {
                    (t, { i18n }) => (
                        <div id="focus">
                            <div id="focus-header"><h1>{t('system.name')}</h1></div>
                            <div className="main">
                                <div className="main-wrap">
                                    <div className="focus-wrap">
                                        <div className='box-header'>
                                            <h2>{t('system.enter_verfication_num')}</h2>
                                        </div>
                                        <div className="form-item">
                                            <input type="text" value={code} onChange={this.updateState('code')} />
                                        </div>
                                        <ListErrors errors={this.props.errors} />
                                        <div className="form-item">
                                            <button onClick={this.checkPinCode(code)}>{this.props.inProgress ? t('system.submit_verify_code_progress') : t('system.submit_verify_code')}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
            </Translation>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Verification)
